import React, { useEffect } from "react";
import "./styles.scss";
import { unregisterFCMToken } from "../../services/firebase/notificationService";

export default function Unauthorized() {
  useEffect(() => {
    setTimeout(async () => {
      await unregisterFCMToken();
      window.location.href = "/logout";
    }, 2500);
  }, []);
  return (
    <div className="error-page">
      <div className="error-info">
        <p className="title">Unauthorized access.</p>
      </div>
    </div>
  );
}
